var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-auto-complete',{attrs:{"placeholder":_vm.$props.placeholder,"data-source":_vm.data,"filter-option":false},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }